<template>
  <div id="save-programme" style="display:none;background: #FFFFFF;">
    <br />
    <div class="modal-content">
      <div class="modal-body">
        <label
          v-if="$route.name === 'edit' || titleTemplate.title"
          id="txt-modal-edit"
          style="display: block;font-size: 18px;text-align: left;"
        >
          {{ $t('labels.edit_template_name') }}
        </label>
        <label v-else id="txt-modal" style="display: block;font-size: 18px;text-align: left;">{{
          $t('labels.add_template_name')
        }}</label>
        <input
          id="title-template"
          class="form-control"
          v-show="!($route.name === 'edit' || titleTemplate.title)"
          type="text"
          :placeholder="$t('placeholder.template_title')"
          name="fname"
          style="padding-left: 15px;height: 45px;font-size: 18px;border-radius: 0;"
        />
        <input
          v-show="$route.name === 'edit' || titleTemplate.title"
          id="edit-title-template"
          class="form-control"
          v-model="title"
          type="text"
          :placeholder="$t('placeholder.template_title')"
          name="fname"
          style="padding-left: 15px;height: 45px;font-size: 18px;border-radius: 0;"
        />
      </div>
      <br />
      <div class="modal-footer">
        <button id="success" class="button-saveTemp">
          <i
            id="loadButton"
            class="fa fa-spinner fa-spin"
            style="margin-right: 10px; display: none"
          >
          </i
          >{{ $t('button.confirm') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      title: '',
    };
  },
  watch: {
    titleTemplate: {
      handler(val) {
        this.title = val.title;
      },
      deep: true,
    },
  },
  computed: {
    /**
     * Getters from Vuex Store
     */
    ...mapGetters({
      titleTemplate: 'slides/getTemplate',
    }),
  },
};
</script>

<style scoped lang="scss">
.button-saveTemp {
  cursor: pointer;
  background: rgb(59, 151, 227);
  border: none;
  width: 159px;
  height: 47px;
  font-size: larger;
  color: rgb(255, 255, 255);
  border-radius: 3px;
  margin-bottom: 25px;
  &[disabled] {
    cursor: not-allowed;
  }
}
.modal-content {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// SaveTemplate.vue?8b25720c